import { SessionUser } from '@/types/user.ts';
import { Member, MemberRole } from '@/models';

let currentUser: SessionUser | null = null;
let sessionToken: string | null = null;

export const getCurrentUser = (): SessionUser | null => currentUser;
export const setCurrentUser = (user: SessionUser | null): void => {
  currentUser = user;
};

export const getSessionToken = (): string | null => sessionToken;
export const setSessionToken = (token: string | null): void => {
  sessionToken = token;
};

export const isServerMember = (
  server: { members: Member[] },
  userId: string
): boolean => {
  return server.members.some((member) => member.profileId === userId);
};

export const getUserServerRole = (
  server: { members: Member[] },
  userId: string
): MemberRole | null => {
  const member = server.members.find((m) => m.profileId === userId);
  return member ? member.role : null;
};
